window.deliveryGroupEdit = function(deliveryGroupData, pageCompanyIds, blockedCompanyIds) {
  return {
    // 企業選択機能
    selectedForDeletion: [],

    // モーダル制御
    isEditModalOpen: false,
    editForm: {
      name: deliveryGroupData.name,
      description: deliveryGroupData.description
    },

    get selectedCount() {
      return this.selectedForDeletion.length;
    },

    init() {
      // ページ読み込み時に選択状態をリセット
      this.selectedForDeletion = [];
    },

    isSelected(companyId) {
      return this.selectedForDeletion.includes(companyId);
    },

    toggleSelection(companyId) {
      const index = this.selectedForDeletion.indexOf(companyId);
      if (index > -1) {
        this.selectedForDeletion.splice(index, 1);
      } else {
        this.selectedForDeletion.push(companyId);
      }
    },

    selectAllOnPage() {
      this.selectedForDeletion = pageCompanyIds.filter(id => !blockedCompanyIds.includes(id));
    },

    deselectAllOnPage() {
      this.selectedForDeletion = [];
    },

    confirmAndSubmit(event) {
      if (this.selectedCount === 0) {
        event.preventDefault();
        return false;
      }

      const message = `選択した${this.selectedCount}社を除外しますか？`;
      if (confirm(message)) {
        event.target.submit();
      }
    },

    // モーダル制御メソッド
    openEditModal() {
      this.editForm.name = deliveryGroupData.name;
      this.editForm.description = deliveryGroupData.description;
      this.isEditModalOpen = true;
    },

    closeEditModal() {
      this.isEditModalOpen = false;
    }
  }
}